
 <template>
    <div>
      <a-spin :spinning="!loading">
        <div :class="!loading ? 'spin-content' : ''">
          <!-- <updatePassword v-if="(usrInfo.loginNum == 0) && loading"  @getInfo="getInfo"></updatePassword> -->
          <company :usrInfo="usrInfo" v-if="loading && usrInfo.auditStatus != 3" @getInfo="getInfo"></company>
        </div>

    </a-spin>
     
    </div>
</template>

<script>
import updatePassword from './commponents/updatePassword.vue'
import company from './commponents/company.vue'
export default {
  components:{
    updatePassword,
    company
  },
  data() {
    return {
      usrInfo:{},
      loading:false,
    };
  },
  beforeCreate() {},
  created() {
    this.loading = false
    this.getInfo();
  },
  methods: {


    getInfo() {
      this.$store.dispatch("user/getInfo").then((res) => {
        this.usrInfo = res
        this.loading = true
        if (res.auditStatus == 3) {
          this.$router.replace({
            path: "/dashboard",
          });
        }
      });
    },
  },
};
</script>

<style lang="scss">
body {
  background-color: #ffffff;
}
.code_class {
  display: flex;
}
.login_title_box {
  font-size: 35px;
  font-weight: bold;
}

.spin-content {
  border: 1px solid #91d5ff;
  background-color: #e6f7ff;
  height: 100vh;
}
</style>
